export const PAGE_SIZE = 10;
export const ENTERPRISE_CONNECTIONS_GUIDE_URL =
  'https://clerk.com/docs/authentication/saml-at-clerk';
